// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w_ey","col":"styles_col__1MBsq"};